import { createContext, ReactNode, useContext } from "react";

import { usePastNotesController } from "./index";

import { ENotesEntity, EPipelineSlug } from "@type/api/management/types";

interface ControllerContextProviderProps {
  children: React.ReactNode;
  pipelineSlug?: EPipelineSlug;
  entityType?: ENotesEntity;
  label?: ReactNode;
}

type TControllerContextValue = ReturnType<typeof usePastNotesController>;

const ControllerContext = createContext<TControllerContextValue>(
  {} as TControllerContextValue
);

const PastNotesControllerContextProvider = ({
  children,
  label,
  pipelineSlug,
  entityType,
}: ControllerContextProviderProps) => {
  const props = usePastNotesController({ pipelineSlug, entityType, label });

  return (
    <ControllerContext.Provider value={props}>
      {children}
    </ControllerContext.Provider>
  );
};

export const usePastNotesControllerContext = () =>
  useContext(ControllerContext);
export default PastNotesControllerContextProvider;
